import { useOptimizationOverview, useOptimizations } from "@web-app/api";
import { Button, Header, LoadingIcon } from "@web-app/components";
import Navigation from "@web-app/pages/common/Navigation";

import OptimizationsList from "./components/OptimizationsList";
import OverviewCards from "./components/OverviewCards";

type CostOptimizerPageProps = {
  logout: () => void;
};

export default function CostOptimizerPage({ logout }: CostOptimizerPageProps) {
  const { data: optimizations = [], isLoading } = useOptimizations();
  const { data: overview } = useOptimizationOverview();

  const startNewOptimization = () => {
    window.location.href = "/cpd/new";
  };

  const openOptimization = (id: string) => {
    window.location.href = `/cpd/new?draftId=${id}`;
  };

  return (
    <div className="h-screen min-h-screen max-w-full">
      <Navigation logout={logout} />

      <div className="h-screen flex-1 overflow-y-auto lg:pl-20">
        <div className="sticky top-0 z-20 bg-white">
          <Header
            icon="truck"
            title="Cost Optimizer"
            description="Compare providers and optimize delivery costs"
            rightActions={
              <Button onClick={startNewOptimization}>
                Start a new optimization
              </Button>
            }
          />
        </div>

        <div className="space-y-6 px-6 py-6">
          <OverviewCards overview={overview} />

          {isLoading ? (
            <div className="flex items-center justify-center p-12">
              <LoadingIcon className="h-8 w-8 animate-spin text-gray-400" />
            </div>
          ) : (
            <OptimizationsList
              optimizations={optimizations}
              onSelect={(optimization) => openOptimization(optimization.id)}
            />
          )}
        </div>
      </div>
    </div>
  );
}
